
<template>

<el-tabs v-model="activeName" type="card">
    <el-tab-pane label="汽车币提现" name="first" :lazy="true">
        <withdraw-cash></withdraw-cash>
    </el-tab-pane>
    <el-tab-pane label="车展币提现" name="second">
        <car-exhibition-withdraw-cash-manager ref="clue-oneBuyCar" :lazy="true"></car-exhibition-withdraw-cash-manager>
    </el-tab-pane>
</el-tabs>

</template>

<script>

import withdrawCash from './withdrawCash'
import carExhibitionWithdrawCashManager from '@/pages/carExhibition/children/carExhibitionWithdrawCashManager'
export default {
  name: 'clue-tab-index',
  components: {
    withdrawCash,
    carExhibitionWithdrawCashManager
  },
  data: function () {
    return {
      activeName: 'first'
    }
  }
}

</script>
